import { cart } from '../constants/globals';

export const getShortsFromCart = (): string[] => {
  return cart.line_items.map((li) => li.product.short_short);
};
